import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { AMAZON_URL } from '../data/content';

const { FiArrowRight } = FiIcons;

// Wiederverwendbarer Amazon-Button (large = groß, sonst kompakt)
function CtaButton({ children, large = false, className = '' }) {
  const size = large ? 'px-7 py-4 text-base sm:text-lg' : 'px-4 py-2 text-sm';
  return (
    <a
      href={AMAZON_URL}
      target="_blank"
      rel="noopener"
      className={`inline-flex items-center justify-center gap-2 rounded-xl bg-[#D52B1E] font-bold text-white shadow-lg shadow-red-900/20 transition hover:-translate-y-0.5 hover:bg-[#b82318] focus:outline-none focus-visible:ring-4 focus-visible:ring-red-300 ${size} ${className}`}
    >
      {children}
      <SafeIcon icon={FiArrowRight} aria-hidden="true" />
    </a>
  );
}

export default CtaButton;